/**
 * Load CrazyEgg event listeners
 */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", function () {

	if (pmwDataLayer?.pixels?.crazyegg?.account_number && !pmwDataLayer?.pixels?.crazyegg?.loaded) {
		if (pmw.consent.canPixelBeFired("statistics", "CrazyEgg") && !pmwDataLayer?.pixels?.crazyegg?.loaded) pmw.loadCrazyeggPixel()
	}
})
